import { styled } from '@clickcease/cc-client-components-lib'

export const CrossSellPricingConfirmationModalStyled = styled('div', {
  display: 'flex',
  position: 'relative',
  width: '570px',
  height: '255px',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
})

export const CrossSellPricingConfirmationModalDescription = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  fontWeight: '$r',
  fontSize: '$h3',
  width: '316px',
  marginTop: '$28',

  variants: {
    modifyPlan: {
      true: {
        width: '88%',
      },
    },
    canceledPlan: {
      true: {
        marginTop: '$20',
      },
    },
  },
})

export const CrossSellPricingConfirmationModalNotice = styled('div', {
  fontSize: '$sm',
  marginTop: '$10',
  width: '70%',
  textAlign: 'center',
})

export const CrossSellPricingError = styled('div', {
  fontSize: '$sm',
  color: '$error',
  marginTop: '$10',
})

export const ModifyPlanErrorWrapper = styled('div', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  color: '$error',
  gap: '$2',

  variants: {
    oldModal: {
      true: {
        flexDirection: 'column',
        gap: 0,
      },
    },
  },
})

export const ModifyPlanErrorTitle = styled('div', {
  variants: {
    oldModal: {
      true: {
        marginTop: '$10',
      },
    },
  },
  marginTop: 0,
})

export const ModifyPlanErrorDescription = styled('div', {
  display: 'flex',
  fontSize: '$md',
})
export const ModifyPlanErrorClickHere = styled('div', {
  fontSize: '$md',
  margin: '0px $2 0px $2',
  cursor: 'pointer',
  textDecoration: 'underline',
})
